import { Container } from 'pixi.js';
import MoveCounter from './moveCounter';
import ScoreCounter from './scoreCounter';
import TimeCounter from './timeCounter';

import { Difficulty } from './difficulty';

import { MonoBehavior } from 'game/core/monoBehavior';
import { Layout } from 'game/LayoutManager';
import { Displays, DESKTOP_SIDEBAR_WIDTH } from 'constants/layout';
import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';
import { getScreenSize } from 'game/core/screen';
import { Store } from 'game/store/gameStore';
import gsap from 'gsap';
import { MENU_TRANSITION_TIME } from 'constants/move';

export class StatisticArea extends MonoBehavior {
    moveCounter: MoveCounter;
    scoreCounter: ScoreCounter;
    timeCounter: TimeCounter;
    difficulty: Difficulty;
    container: Container;

    constructor(contentContainer: Container) {
        super();
        this.moveCounter = new MoveCounter();
        this.scoreCounter = new ScoreCounter();
        this.timeCounter = new TimeCounter();
        this.difficulty = new Difficulty();
        this.container = new Container();

        contentContainer.addChild(this.container);
        this.container.addChild(this.moveCounter.container);
        this.container.addChild(this.scoreCounter.container);
        this.container.addChild(this.timeCounter.container);
        this.container.addChild(this.difficulty.container);

        this.difficulty.container.position.set(-9999, 0);
        this.moveCounter.container.position.set(-9999, 0);
        this.timeCounter.container.position.set(-9999, 0);
        this.scoreCounter.container.position.set(-9999, 0);

        GameEvent.add(EventName.CHANGE_LANGUAGE, this.resize);
        GameEvent.add(EventName.UPDATE_STATISTICS, this.resize);
        GameEvent.add(EventName.START_TUTORIAL, this.onTutorialChange.bind(this, true));
        GameEvent.add(EventName.STOP_TUTORIAL, this.onTutorialChange.bind(this, false));
    }

    public removeDifficulty(): void {
        this.difficulty.container.destroy();
        this.difficulty.destroy();
    }

    resize() {
        const device = Layout.getDisplay();
        this.moveCounter.refresh();
        this.timeCounter.refresh();
        this.scoreCounter.refresh();
        const moveWidth = this.moveCounter.getWidth();
        const timeWidth = this.timeCounter.getWidth();
        const startX = Layout.getColumnPosition(0).x - Layout.getCardSize().width / 2;
        const gap = Store.isPyramid ? -67 : 0;
        switch (device) {
            case Displays.DESKTOP:
                this.container.position.x = 0;

                this.moveCounter.container.position.set(DESKTOP_SIDEBAR_WIDTH * 0.5, 104 + gap);
                this.timeCounter.container.position.set(DESKTOP_SIDEBAR_WIDTH * 0.5, 170 + gap);
                this.scoreCounter.container.position.set(DESKTOP_SIDEBAR_WIDTH * 0.5, 238 + gap);
                break;
            case Displays.TABLET:
                this.container.position.x = getScreenSize().width / 2;
                this.moveCounter.container.position.set(startX, 15);
                this.timeCounter.container.position.set(this.moveCounter.container.position.x + moveWidth + 30, 15);
                this.scoreCounter.container.position.set(this.timeCounter.container.position.x + timeWidth + 30, 15);
                break;
            case Displays.MOBILE:
                this.container.position.x = getScreenSize().width / 2;

                this.moveCounter.container.position.set(startX, 10);
                this.timeCounter.container.position.set(this.moveCounter.container.position.x + moveWidth + 30, 10);
                this.scoreCounter.container.position.set(this.timeCounter.container.position.x + timeWidth + 30, 10);
                break;
        }
    }
    onTutorialChange(isStarted: boolean) {
        if (isStarted) {
            gsap.to(this.container, { alpha: 0, duration: MENU_TRANSITION_TIME });
        } else {
            gsap.to(this.container, { alpha: 1, duration: MENU_TRANSITION_TIME });
        }
    }
}
